import React, { Component } from "react";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import CalenderData from "./screens/dataViewer/CalenderData";
import SpeechCalenderData from "./screens/dataViewer/SpeechCalenderData";
import { Line } from "rc-progress";
import { Tabs, message, Spin } from "antd";
import Charts from "./screens/dataViewer/Charts";
import AlsfrsBreakdown from "./screens/dataViewer/AlsfrsBreakdown";
import KeyStatistics from "./screens/dataViewer/KeyStatistics";
import ECAS from "./screens/dataViewer/ECAS";
import PhysicalECASForms from "./screens/dataViewer/PhysicalECASForms";
import SpeechDataDownload from "./screens/dataViewer/SpeechDataDownload";
import ActiGraph from "./screens/dataViewer/ActiGraph";
import Bridge from "./utils/Bridge";
import { RESEARCH_TYPE } from "./utils/consts";
import { logEvent } from "./utils/analytics";
import moment from "moment";

import LeStudyPersonalDataViewer from "./screens/leStudy/PersonalDataViewer";
import LEStudyTabs from "./screens/leStudy/SessionList";

import englishJson from "./utils/language/leStudy/english.json";
import spanishJson from "./utils/language/leStudy/spanish.json";
import noLanguageJson from "./utils/language/leStudy/noLanguage.json";
import EcasStudyAlsfrsrScore from "./screens/ecasStudy/Alsfrsr";

const TOTAL_WEEKS = 52;

export default class PersonalDataViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: "",
      percentage: 0,
      sessions: [],
      totalSession: "05",
      lastSessionDate: "",
      session_link: "",
      client_code: "",
      is_loaded: false,
      session_data: {},
      next_session_start_date: "",
      next_session_end_date: "",
      total_session_completed: 0,
      calenderLoading: false,
      procotored_session_list: [],
      last_session_date: "",
      no_of_sessions: 0,
      no_of_streaks: 0,
      progressBarPercent: 0,
      total_sessions: 0,
      speech_portal_link: "",
    };
  }
  componentDidMount() {
    if (
      RESEARCH_TYPE == "Asymptomatic Study" ||
      RESEARCH_TYPE == "ECAS Study"
    ) {
      this.get_client_code();
      this.get_session_details();
    } else if (RESEARCH_TYPE == "modality.ai") {
      this.get_speech_client_code();
    }
  }
  get_speech_client_code = () => {
    let params =
      `?participants_accounts_id=` +
      localStorage.getItem("ap_participants_accounts_id");
    Bridge.personal_data_viewer.speech
      .get_speech_client_code(params)
      .then((res) => {
        if (res.status == 1) {
          // return console.log('res',res);

          let speech_portal_link = res.data.portal_link;
          let client_code = res.data.client_code;

          this.setState(
            {
              client_code: client_code,
              speech_portal_link: speech_portal_link,
            },
            () => {
              if (client_code) {
                this.get_session_data(client_code);
                this.get_datadownloads(client_code);
              }
            }
          );
        }
      });
  };
  get_datadownloads = (client_code) => {
    let params = `/${client_code}?stat=datadownload`;
    Bridge.personal_data_viewer.get_datadownload_list(params).then((res) => {
      if (res.status == 200) {
        let data = res.data;
        // Convert data to tree structure
        if (data && data.results && data.results.length > 0) {
          let arr = data.results.sort(
            (a, b) => new Date(b.date) - new Date(a.date)
          );
          this.setState(
            {
              no_of_sessions: arr.length,
              sessions: data.results,
            },
            () => {
              if (arr.length > 0) {
                this.calculate_data_form_message(arr);
              }
            }
          );
        }
      }
    });
  };
  calculate_data_form_message = (arr) => {
    //number of sessions
    //streak is done
    let streak = 0;
    let reverseArray = arr;
    reverseArray = arr.sort((a, b) => new Date(b.date) - new Date(a.date));
    if (reverseArray.length > 0) {
      let i = 0;
      for (const item of reverseArray) {
        let gap = moment(item.date).diff(
          moment(reverseArray[i + 1]?.date),
          "days"
        );
        gap = Math.abs(gap);
        if (Number(gap) <= 7) {
          streak++;
        } else {
          break;
        }
        i++;
      }

      // for (let i = 0; i < reverseArray.length; i++) {
      //   let gap = moment(reverseArray[i].date).diff(
      //     moment(reverseArray[i + 1].date),
      //     "days"
      //   );
      //   gap = Math.abs(gap);
      //   if (Number(gap) <= 7) {
      //     streak++;
      //   } else {
      //     break;
      //   }
      // }
    }
    this.setState({ no_of_streaks: streak });
  };
  get_session_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    this.setState({ calenderLoading: true });
    Bridge.personal_data_viewer
      .get_proctored_session_details(params)
      .then((res) => {
        if (res.status == 1) {
          this.setState({
            lastSessionDate: res.data.last_proctored_session_date,
            next_session_start_date: res.data.next_session_start_date,
            next_session_end_date: res.data.next_session_end_date,
            total_session_completed:
              Number(res.data.total_session_completed) >= 10
                ? res.data.total_session_completed.toString()
                : res.data.total_session_completed.toString().padStart(2, "0"),
            sessions: res.data.session_list,
            procotored_session_list: res.data.procotored_session_list,
            calenderLoading: false,
          });
        } else {
          this.setState({ calenderLoading: false });
        }
      })
      .catch((err) => {
        this.setState({ calenderLoading: false });
      });
  };
  get_client_code = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.personal_data_viewer
      .get_asymptomatic_client_code(params)
      .then((res) => {
        if (res.status == 1) {
          let client_code = res.data; //pg50p4
          // let client_code = "pg50p4"; //pg50p4
          this.setState(
            {
              client_code: client_code,
              is_loaded: true,
            },
            () => this.get_session_data(client_code)
          );
        } else {
          this.setState({ is_loaded: true });
        }
      });
  };
  get_session_data = (client_code) => {
    let params = `/${client_code}?stat=session`;
    Bridge.personal_data_viewer.get_session_data(params).then((res) => {
      if (res.status == 200) {
        this.setState({
          session_data: res.data,
        });
        if (RESEARCH_TYPE == "modality.ai") {
          this.setState({
            last_session_date: moment(res.data.LAST_SESSION_DATE).format(
              "Do MMMM YYYY"
            ),
            total_sessions: res.data.TOTAL_SESSIONS
              ? res.data.TOTAL_SESSIONS
              : 0,
          });

          let totalSessions = res.data?.TOTAL_SESSIONS;
          let frac = this.calculateProgress(totalSessions);
          let per = frac * 100;
          this.setState({ progressBarPercent: per });
        }
      }
    });
  };
  calculateProgress = (val) => {
    if (val > TOTAL_WEEKS) {
      return Math.round((100 * 100.0) / TOTAL_WEEKS) / 100;
    } else {
      return Math.round((val * 100.0) / TOTAL_WEEKS) / 100;
    }
  };
  open_speech_session = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.personal_data_viewer
      .get_start_speech_session_link(params)
      .then((res) => {
        if (res.status == 1) {
          let link = res.data;

          window.open(link, "_blank");
        } else {
          message.warning(res.message);
        }
      });
  };

  openPrintReportModal = () => {
    // Open report in a new window
    const reportUrl = `/print-report?eals_id=${localStorage.getItem(
      "ap_eals_id"
    )}`;
    window.open(reportUrl, "_blank", "width=1200,height=800");
  };

  closePrintReportModal = () => {
    this.setState({ showPrintReportModal: false });
  };
  onChange = (key) => {
    const tabLabels = {
      "Asymptomatic Study": { "1": "Charts", "2": "ALSFRS Breakdown", "4": "Speech Session Data", "5": "ActiGraph Data", "6": "ECAS" },
      "modality.ai":        { "1": "Charts", "2": "ALSFRS / ROADS Breakdown", "3": "Key Statistics", "4": "Data Download" },
      "ECAS Study":         { "1": "Physical ECAS", "2": "ALSFRS-R" },
    };
    const label = (tabLabels[RESEARCH_TYPE] || {})[key] || key;
    logEvent("data_viewer_tab_selected", { tab: label });
  };
  render() {
    const notAvailableStyles = {
      fontSize: 19,
      textAlign: "center",
      padding: "16px 0px 0px",
    };
    const progressBarWrapperStyles = {
      marginBottom: 30,
    };
    const progressBarSpanStyles = {
      display: "flex",
      justifyContent: "center",
      marginBottom: 9,
    };
    const ASYMPTOMATIC_ITEMS = [
      {
        key: "1",
        label: `Charts`,
        children: (
          <>
            {this.state.client_code && this.state.session_data && (
              <Charts
                client_code={this.state.client_code}
                sessionData={this.state.session_data}
              />
            )}
            {!this.state.client_code && (
              <p className="text-center" style={notAvailableStyles}>
                Not available.
              </p>
            )}
          </>
        ),
      },
      {
        key: "2",
        label: `ALSFRS Breakdown`,
        children: (
          <>
            {this.state.is_loaded == true && (
              <AlsfrsBreakdown client_code={this.state.client_code} />
            )}
          </>
        ),
      },
      {
        key: "4",
        label: `Speech Session Data`,
        children: <SpeechDataDownload client_code={this.state.client_code} />,
      },
      {
        key: "5",
        label: `ActiGraph Data`,
        children: <ActiGraph />,
      },
      {
        key: "6",
        label: `ECAS`,
        children: <ECAS />,
      },
      // {
      //   key: "1",
      //   label: `ALSFRS-R`,
      //   children: <Alsfrs sessions={this.state.sessions} />,
      // },
      // {
      //   key: "2",
      //   label: `ARES Score`,
      //   children: <AresScore sessions={this.state.sessions} />,
      // },
      // {
      //   key: "3",
      //   label: `CPIB Form`,
      //   children: <CpibForm sessions={this.state.sessions} />,
      // },
      // {
      //   key: "4",
      //   label: `ROADS`,
      //   children: <Roads />,
      // },
    ];
    const SPEECH_ITEMS = [
      {
        key: "1",
        label: `Charts`,
        children: (
          <>
            {this.state.client_code && this.state.session_data && (
              <Charts
                client_code={this.state.client_code}
                sessionData={this.state.session_data}
              />
            )}
            {!this.state.client_code && (
              <p className="text-center" style={notAvailableStyles}>
                Not available.
              </p>
            )}
          </>
        ),
      },
      {
        key: "2",
        label: `ALSFRS / ROADS Breakdown`,
        children: (
          <>
            {this.state.client_code && (
              <AlsfrsBreakdown client_code={this.state.client_code} />
            )}
            {!this.state.client_code && (
              <p className="text-center" style={notAvailableStyles}>
                Not available.
              </p>
            )}
          </>
        ),
      },
      {
        key: "3",
        label: `Key Statistics`,
        children: (
          <>
            {this.state.client_code && (
              <KeyStatistics client_code={this.state.client_code} />
            )}
          </>
        ),
      },
      {
        key: "4",
        label: `Data Download`,
        children: <SpeechDataDownload client_code={this.state.client_code} />,
      },
      // {
      //   key: "1",
      //   label: `ALSFRS-R`,
      //   children: <Alsfrs sessions={this.state.sessions} />,
      // },
      // {
      //   key: "2",
      //   label: `ARES Score`,
      //   children: <AresScore sessions={this.state.sessions} />,
      // },
      // {
      //   key: "3",
      //   label: `CPIB Form`,
      //   children: <CpibForm sessions={this.state.sessions} />,
      // },
      // {
      //   key: "4",
      //   label: `ROADS`,
      //   children: <Roads />,
      // },
    ];
    const ECAS_ITEMS = [
      {
        key: "1",
        label: `PHYSICAL ECAS`,
        children: <PhysicalECASForms />,
      },
      {
        key: "2",
        label: `ALSFRS-R`,
        children: <EcasStudyAlsfrsrScore />,
      },
    ];
    const ITEMS = [];
    const formData =
      RESEARCH_TYPE === "LE Study"
        ? this.props.language === "English"
          ? englishJson
          : this.props.language === "Spanish"
            ? spanishJson
            : noLanguageJson
        : englishJson;
    return (
      <div>
        <Header />
        <div className="main-content demographics-wrapper">
          <div className="container" style={{ minHeight: 300 }}>
            <div className="row">
              <div className="col-lg-12 m-auto">
                <a href="/dashboard" className="dashboard-back-arrow mt-0">
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  {formData.page.backButtonTextDashboard}
                </a>
                <div
                  style={{
                    background: "#fff",
                    padding: "15px 20px",
                  }}
                >
                  <h2 className="mt-2">
                    {formData.page.personalDataViewer.title}
                  </h2>
                  <br />
                  {RESEARCH_TYPE == "Asymptomatic Study" && (
                    <div className="row">
                      <div className="col-lg-7">
                        <Spin spinning={this.state.calenderLoading}>
                          {this.state.sessions &&
                            this.state.sessions.length > 0 && (
                              <CalenderData
                                sessions={this.state.sessions}
                                procotored_session_list={
                                  this.state.procotored_session_list
                                }
                              />
                            )}
                          {this.state.sessions.length == 0 && (
                            <CalenderData sessions={this.state.sessions} />
                          )}
                        </Spin>
                      </div>
                      <div className="col-lg-5">
                        {/* Session Card  */}
                        <div className="card-wrapper session-details">
                          <h1>{this.state.total_session_completed} / 08</h1>
                          <p>Sessions Completed</p>
                        </div>
                        <div className="card-wrapper update-details-card mt-3">
                          {this.state.lastSessionDate && (
                            <p>
                              Date of Last Proctored Session:{" "}
                              {this.state.lastSessionDate}
                            </p>
                          )}
                          {this.state.lastSessionDate && (
                            <p>
                              Next Projected Session: <br />
                              From: {
                                this.state.next_session_start_date
                              } To: {this.state.next_session_end_date}
                            </p>
                          )}
                          <div style={progressBarWrapperStyles}>
                            <span style={progressBarSpanStyles}>
                              {this.state.total_session_completed} / 08
                            </span>
                            <Line
                              percent={this.state.progressBarPercent}
                              strokeWidth={6}
                              trailWidth={6}
                              strokeColor="#6cd300"
                            />
                            <button
                              onClick={() => this.open_speech_session()}
                              style={{ marginBottom: 25 }}
                            >
                              Start Speech Session
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {RESEARCH_TYPE == "modality.ai" && (
                    <div className="row">
                      <div className="col-lg-7">
                        <Spin spinning={this.state.calenderLoading}>
                          {this.state.sessions &&
                            this.state.sessions.length > 0 && (
                              <SpeechCalenderData
                                sessions={this.state.sessions}
                              />
                            )}
                          {this.state.sessions.length == 0 && (
                            <SpeechCalenderData
                              sessions={this.state.sessions}
                            />
                          )}
                        </Spin>
                      </div>
                      <div className="col-lg-5">
                        {/* Session Card  */}
                        <div className="state_data_section card-wrapper session-details">
                          <div className="row" style={{ width: "100%" }}>
                            <div className="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-4">
                              <div className="active-days">
                                <h4>{this.state.total_sessions}</h4>
                                <span>Sessions</span>
                              </div>
                            </div>
                            <div className="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-4">
                              <div className="active-days">
                                <h4>{this.state.no_of_streaks}</h4>
                                <span>
                                  Week
                                  <br /> Streak
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card-wrapper update-details-card mt-3">
                          {this.state.session_data.LAST_SESSION_DATE && (
                            <p className="mb-2">
                              Date of Last Session:{" "}
                              {this.state.last_session_date
                                ? this.state.last_session_date
                                : "--"}
                            </p>
                          )}
                          <div style={progressBarWrapperStyles}>
                            {this.state.speech_portal_link ? (
                              <a
                                href={this.state.speech_portal_link}
                                target="_blank"
                                className="red_big_button d-flex text-center justify-content-center align-items-center w-100"
                                style={{ marginTop: 20 }}
                                onClick={() => logEvent("session_started")}
                              >
                                Start My Next Session
                              </a>
                            ) : this.state.client_code ? (
                              <a
                                href={`https://webapi.modality.ai/avdialogue/prod/12/html/call.html?x=1230&i=${this.state.client_code}`}
                                target="_blank"
                                className="red_big_button d-flex text-center justify-content-center align-items-center w-100"
                                style={{ marginTop: 20 }}
                                onClick={() => logEvent("session_started")}
                              >
                                Start My Next Session
                              </a>
                            ) : (
                              <a
                                href={`#`}
                                target="_blank"
                                className="red_big_button d-flex text-center justify-content-center align-items-center w-100"
                                style={{ marginTop: 20 }}
                                onClick={() => logEvent("session_started")}
                              >
                                Start My Next Session
                              </a>
                            )}
                          </div>
                        </div>
                        <div className="card-wrapper update-details-card mt-3">
                          <div style={{ marginBottom: 15 }}>
                            <div>
                              <div className="py-3">
                                <div
                                  className="fw-bolder"
                                  style={{ fontSize: 18 }}
                                >
                                  Weeks Completed:
                                </div>
                              </div>
                            </div>
                            <div
                              className="progress rounded-pill position-relative"
                              style={{ height: "30px" }}
                            >
                              <Line
                                percent={this.state.progressBarPercent}
                                strokeWidth={6}
                                trailWidth={6}
                                strokeColor="#6cd300"
                              />
                              <div
                                className="position-absolute fw-bolder fs-5 end-10"
                                style={{ right: 10 }}
                              >
                                {this.state.total_sessions > TOTAL_WEEKS
                                  ? this.state.total_sessions
                                  : `${this.state.total_sessions}/${TOTAL_WEEKS}`}
                              </div>
                            </div>
                            <a
                              target="_blank"
                              href="/profile"
                              className="red_big_button d-flex text-center justify-content-center align-items-center w-100"
                              style={{ marginTop: 20 }}
                            >
                              Update My Profile
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {RESEARCH_TYPE == "LE Study" && (
                    <LeStudyPersonalDataViewer
                      language={this.props.language}
                      onOpenPrintReport={this.openPrintReportModal}
                    />
                  )}
                  <div
                    className="main-section"
                    style={{ marginTop: 35, marginBottom: 35 }}
                  >
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="tabs-section personal_data_viewer_tab">
                          {RESEARCH_TYPE == "ECAS Study" && (
                            <>
                              <Tabs
                                defaultActiveKey="1"
                                items={ECAS_ITEMS}
                                onChange={this.onChange}
                                tabBarExtraContent={(
                                  // Temporarily hidden. Kept for future re-enable.
                                  // <a
                                  //   href="/ecas-live-session"
                                  //   className="red_big_button d-flex text-center justify-content-center align-items-center"
                                  //   style={{ padding: "5px 20px" }}
                                  // >
                                  //   Start Active session
                                  // </a>
                                  null
                                )}
                              />
                            </>
                          )}
                          {RESEARCH_TYPE == "LE Study" && (
                            <LEStudyTabs language={this.props.language} />
                          )}
                          {RESEARCH_TYPE != "ECAS Study" && (
                            <Tabs
                              defaultActiveKey="1"
                              items={
                                RESEARCH_TYPE === "Asymptomatic Study"
                                  ? ASYMPTOMATIC_ITEMS
                                  : RESEARCH_TYPE === "modality.ai"
                                  ? SPEECH_ITEMS
                                  : ITEMS
                              }
                              onChange={this.onChange}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
